import { getBouLinkStyle } from '@upright/ui/common/generic/content/texts/bou-link';
import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { mobileOrNarrower } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';
import { useSubscriptionContext } from '../../context';

export const BackLink = () => {
  const context = useSubscriptionContext();
  const [params, setParams] = context.params;
  const isStartPage = params.tier === undefined;
  const isSuccessPage = params.success;

  if (isStartPage || isSuccessPage) {
    return null;
  }

  return (
    <Root
      onClick={() => {
        setParams({ tier: undefined });
      }}
    >
      ← Change plan
    </Root>
  );
};

const Root = styled.span`
  ${getBouLinkStyle(false, undefined, 'lighter')}
  ${getTextStyle({ size: 'xxs' })}
  /* This link is the left-hand item of the subscription modal's right-aligned action row, so it takes
     the free space and leaves Submit at the right (DESIGN.md, "Where the action row goes"). It comes
     first in the DOM there too, so nothing is reordered in CSS. Set on this element rather than on a
     wrapper div, because a wrapper adds a line box of its own and shifts the link down by a pixel.
     Inert below tablet, where the link is hidden. */
  margin-right: auto;
  ${mobileOrNarrower(css`
    display: none;
  `)}
`;
